// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Filter20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Filter20: FC<Filter20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M11 7.5V6h2.25V3h1.5v3H17v1.5h-6Zm2.25 9.5V9h1.5v8h-1.5Zm-8 0v-3H3v-1.5h6V14H6.75v3h-1.5Zm0-6V3h1.5v8h-1.5Z" />
        </svg>
    );
};

export default Filter20;
